import { useState } from 'react';
import type { QuantAnalysisFilter } from '@trinity/chat/src/api/interfaces/projects.quant-analysis';
import { QuantAnalysisFilterContext } from './context';

export const QuantAnalysisFilterContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [quantFilter, setQuantFilter] = useState<QuantAnalysisFilter>({
    columnNames: [],
    rowNames: [],
    sortConfig: null,
    selection: {
      rows: new Set<number>(),
      columns: new Set<number>(),
      cells: new Map<string, boolean>(),
    },
    customColumnNames: new Map(),
    customRowNames: new Map(),
  });

  return (
    <QuantAnalysisFilterContext.Provider value={[quantFilter, setQuantFilter]}>
      {children}
    </QuantAnalysisFilterContext.Provider>
  );
};